export default __webpack_public_path__ + "static/media/discount-card.d0635d0c.pdf";